<template>
    <section id="reviews" class="scroll-mt-24">
        <h3 class="text-lg font-semibold mb-6">{{ $t('Reviews') }}</h3>

        <template v-for="review in reviews" :key="review.id">
            <div class="mb-6 space-y-4">
                <!-- Author -->
                <div class="space-y-1">
                    <h3 class="text-base font-semibold text-gray-900">
                        {{ review.customerName }}
                    </h3>
                    <p class="text-sm text-gray-500">
                        {{ review.customerCountry }}
                    </p>
                </div>

                <!-- Rating + time -->
                <div class="space-y-2">
                    <div class="flex items-center gap-2">
                        <div class="flex text-sm gap-0.5">
                            <i
                                v-for="(star, i) in stars(review.score)"
                                :key="i"
                                class="icon-star"
                                :class="{
                                    'text-primary': star !== 'empty',
                                    'text-gray-300': star === 'empty',
                                    'opacity-60': star === 'half'
                                }"
                            />
                        </div>

                        <span class="text-sm text-gray-500">
                            {{ $d(review.createdAt) }}
                        </span>
                    </div>

                    <p class="text-gray-800 text-sm/normal">
                        {{ review.text }}
                    </p>
                </div>
            </div>
        </template>
    </section>
</template>

<script setup>
defineProps({
    reviews: {
        type: Array,
        required: true,
        default: () => []
    }
})

const stars = (score) => {
    const value = score / 20 // 0–100 → 0–5
    const full = Math.floor(value)
    const half = value % 1 >= 0.5 ? 1 : 0
    const empty = 5 - full - half

    return [...Array(full).fill('full'), ...Array(half).fill('half'), ...Array(empty).fill('empty')]
}
</script>
